import { FormikProps } from "formik";
import { InvoiceFormTypes } from "models/formTypes";
import { ForwardedCostsFooterActions } from "models/propTypes/invoicePropTypes";

type InvoiceForm = FormikProps<InvoiceFormTypes.Create>;

/**
 * Runs a save or preview handler once the forwarded costs' files are in the form, on the values that hold them: the
 * form the handler was rendered with still has the values from before the files arrived.
 */
function waitForForwardedCostAttachments<TArgs extends unknown[], TResult>(
  form: InvoiceForm,
  forwardedCosts: Pick<ForwardedCostsFooterActions, "waitForAttachments" | "getLatestValues"> | undefined,
  handler: (form: InvoiceForm, ...args: TArgs) => Promise<TResult>
) {
  return async (...args: TArgs): Promise<TResult> => {
    if (!forwardedCosts) return handler(form, ...args);
    await forwardedCosts.waitForAttachments();
    return handler({ ...form, values: forwardedCosts.getLatestValues() }, ...args);
  };
}

export default waitForForwardedCostAttachments;
